export default "__VITE_ASSET__keRAjNb5__"